<template>
  <div>
    <div v-if="$config.show_low_balance_notification" class="low-balance-banner">{{ $t('core.dashboard.low-balance') }}</div>

    <div class="theme-container">
      <sidebar key="sidebar" />
      <div class="content-wrapper">
        <header-component key="header" />
        <app-view class="page-content" />
        <footer-component key="footer" />
        <messangers-component />
      </div>
    </div>
  </div>
</template>

<script>
  import Sidebar from '@shared/components/layout-default/layout-default-sidebar';
  import HeaderComponent from '@shared/components/layout-default/layout-default-header';
  import FooterComponent from '@shared/components/layout-default/layout-default-footer';
  import MessangersComponent from '@shared/components/layout-default/layout-default-messangers';

  import { mapActions } from 'vuex';
  import { is_allow_route } from '@shared/helpers/permissions';

  export default {
    components: {
      Sidebar,
      HeaderComponent,
      FooterComponent,
      MessangersComponent
    },

    watch: {
      $route: {
        handler: function (route) {
          this.set_current_reacrumbs(route.name);
          this.$nextTick(() => this.check_permission(route));
        },
        immediate: true
      }
    },

    methods: {
      ...mapActions('shared/breadcrumbs', { set_current_reacrumbs: 'set_current' }),
      check_permission(route) {
        try {
          if (!is_allow_route(route, this.$permission, this.$config)) {
            this.showPageErrorByCode(403);
          }
        } catch (e) {
          this.showPageErrorByCode(520);
        }
      }
    }
  };
</script>
